import { useCallback, ReactElement } from "react";
import { useDispatch } from "react-redux";
import {
  LoqateAddressFieldConfig,
  MelissaAddressFieldConfig,
} from "@evergiving/common/dist/es2015/form";

import { LabelledField } from "@/lib/components/LabelledField";
import { LabelText } from "@/lib/components/LabelText";
import { setPostalAddress } from "@/lib/redux/actions";

export function SearchAddressWithProviderField({
  searchAddressProviderFieldConfig,
  addressLine,
}: {
  searchAddressProviderFieldConfig:
    | MelissaAddressFieldConfig
    | LoqateAddressFieldConfig;
  addressLine: string;
}): ReactElement {
  const dispatch = useDispatch();
  const handleChangeAddress = useCallback(() => {
    dispatch(setPostalAddress(undefined));
  }, [dispatch]);

  return (
    <LabelledField id="billingAddress">
      <LabelText>{searchAddressProviderFieldConfig.labelText}</LabelText>
      <div className="addressFormatted">
        <div className="addressLines">{addressLine}</div>
        <div className="addressButtonContainer">
          <button
            type="button"
            onClick={handleChangeAddress}
            className="addressChangeButton"
          >
            {searchAddressProviderFieldConfig.changeAddressButtonText}
          </button>
        </div>
      </div>
    </LabelledField>
  );
}
